<template>
    <v-container :class="!isLaunchAsPopup ? 'pa-5' : ''" fluid>
        <CreatedStopCardsDialog
            v-if="complaint.createdStopCards"
            :is-open="createdStopCardsDialog"
            :created-stop-cards="complaint.createdStopCards"
            @on-close="closeCreatedStopCardsDialog"
        />
        <ConfirmDialog
            :is-open="confirmComplaintDialog"
            :data="complaint"
            @on-confirm="confirmComplaint(complaint)"
            @on-abort="closeConfirmComplaintDialog"
        >
            <template #title>
                Potwierdzenie zapoznania się z reklamacją
            </template>
            <template #content>
                Czy na pewno chcesz potwierdzić?
            </template>
        </ConfirmDialog>
        <ConfirmDialog
            :is-open="confirmDraftComplaintDialog"
            :data="complaint"
            @on-confirm="confirmDraftComplaint(complaint)"
            @on-abort="closeConfirmDraftComplaintDialog"
        >
            <template #title>
                Potwierdzenie przekazania reklamacji do DKJ
            </template>
            <template #content>
                Czy na pewno chcesz przekazać reklamację do DKJ?
            </template>
        </ConfirmDialog>

        <TryToCloseStopCardDialog
            v-if="showCloseStopCardDialog"
            :is-open="showCloseStopCardDialog"
            :stop-cards="stopCardsForClosing"
            way-of-closing="RW"
            @close="showCloseStopCardDialog = false"
        />

        <template
            v-if="!isLaunchAsPopup"
        >
            <page-title>{{ pageTitle }}</page-title>
            <v-row align="center">
                <v-col class="pb-0">
                    <v-btn
                        text
                        color="primary"
                        class="pa-0"
                        :disabled="actionLoading.saveComplaint || fileUploadPending"
                        @click="close"
                    >
                        <v-icon color="primary">
                            mdi-arrow-left
                        </v-icon>
                        Powrót do listy
                    </v-btn>
                </v-col>
            </v-row>
        </template>
        <v-row align="center">
            <v-container fluid class="py-0">
                <v-row justify="end" dense>
                    <v-col cols="auto">
                        <v-btn
                            v-if="isStopCardsButtonVisible"
                            color="primary"
                            outlined
                            medium
                            data-sentry-label="karty stop"
                            :disabled="complaint.createdStopCards.length === 0"
                            @click="showCreatedStopCards"
                        >
                            Karty stop
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-row>
        <v-row tag="form">
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-card
                                :loading="loading"
                            >
                                <v-tabs
                                    v-model="tabs"
                                    background-color="transparent"
                                    slider-color="blue"
                                >
                                    <v-tab>
                                        Szczegóły
                                    </v-tab>
                                    <v-tab>
                                        Załączniki
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateComplaint'">
                                        Przyczyny
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateComplaint'">
                                        Zalecenia
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateComplaint' || selectedComplaintTypeId === 1">
                                        Akcje
                                    </v-tab>
                                    <v-tab v-if="actionName === 'updateComplaint'">
                                        Komentarze
                                    </v-tab>
                                    <v-tab v-if="executionTabVisible">
                                        Wykonanie
                                    </v-tab>

                                    <v-tabs-items v-model="tabs">
                                        <v-divider />
                                        <v-tab-item>
                                            <v-card flat>
                                                <v-card-text>
                                                    <Details
                                                        :complaint="complaint"
                                                        :is-internal="isComplaintInternal"
                                                        :validations="$v"
                                                        :action="actionName"
                                                        :can-save-complaint="canSaveComplaint"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item>
                                            <Attachment
                                                :complaint="complaint"
                                                :uploaded-files="complaint.complaintAttachment"
                                                :can-save-complaint="canSaveComplaint"
                                                @add-complaint-attachment="addComplaintAttachment"
                                                @delete-complaint-attachment="deleteComplaintAttachment"
                                            />
                                        </v-tab-item>
                                        <v-tab-item v-if="actionName === 'updateComplaint'">
                                            <v-card flat>
                                                <v-card-text>
                                                    <Causes
                                                        :complaint="complaint"
                                                        :validations="$v"
                                                        :can-save-complaint="canSaveComplaint"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item v-if="actionName === 'updateComplaint'">
                                            <v-card flat>
                                                <v-card-text>
                                                    <Commissions
                                                        :complaint="complaint"
                                                        :validations="$v"
                                                        :can-save-complaint="canSaveComplaint"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item v-if="actionName === 'updateComplaint' || selectedComplaintTypeId === 1">
                                            <v-card flat>
                                                <v-card-text>
                                                    <Submissions
                                                        :complaint="complaint"
                                                        :complaint-status-id="complaint.complaintStatusId"
                                                        :complaint-creator-id="complaint.creator.id"
                                                        :validations="$v"
                                                        :can-save-complaint="canSaveComplaint"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item v-if="actionName === 'updateComplaint'">
                                            <v-card flat>
                                                <v-card-text>
                                                    <Comments
                                                        :complaint="complaint"
                                                        :can-save-complaint="canSaveComplaint"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                        <v-tab-item v-if="executionTabVisible">
                                            <v-card flat>
                                                <v-card-text>
                                                    <Execution
                                                        :orders-data="complaint.ordersData"
                                                    />
                                                </v-card-text>
                                            </v-card>
                                        </v-tab-item>
                                    </v-tabs-items>
                                </v-tabs>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row no-gutters justify="space-between">
                        <v-col v-if="isLaunchAsPopup" cols="auto">
                            <v-btn
                                color="error"
                                medium
                                data-sentry-label="Anuluj"
                                @click="closePopUp"
                            >
                                Anuluj
                            </v-btn>
                        </v-col>
                        <v-col v-if="canSaveComplaint && !isComplaintUneditable" cols="auto">
                            <v-btn
                                color="success"
                                medium
                                class="ml-2"
                                data-sentry-label="Zapisz"
                                :loading="actionLoading.saveComplaint"
                                :disabled="fileUploadPending || actionLoading.confirmComplaint"
                                @click="saveComplaint"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                        <v-col v-if="canConfirmComplaint && isNotConfirmed" cols="auto">
                            <v-btn
                                color="primary"
                                medium
                                class="ml-2"
                                data-sentry-label="Potwierdzenie zapoznania się"
                                :disabled="fileUploadPending || actionLoading.saveComplaint"
                                :loading="actionLoading.confirmComplaint"
                                @click="showConfirmComplaintDialog"
                            >
                                Zapoznałem się
                            </v-btn>
                        </v-col>
                        <v-col v-if="isConfirmDraftButtonVisible && userId === complaint.creator.id" cols="auto">
                            <v-btn
                                color="primary"
                                medium
                                class="ml-2"
                                data-sentry-label="Przekazanie do DKJ"
                                :disabled="actionLoading.saveComplaint"
                                :loading="actionLoading.confirmDraftComplaint"
                                @click="showConfirmDraftComplaintDialog"
                            >
                                Przekaż do DKJ
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import PageTitle from '@/components/common/PageTitle'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import CreatedStopCardsDialog from './CreatedStopCardsDialog'
import TryToCloseStopCardDialog from './TryToCloseStopCardDialog'
import Details from './Details'
import Attachment from './Attachment'
import Causes from './Causes'
import Commissions from './Commissions'
import Submissions from './Submissions'
import Comments from './Comments'
import Execution from './Execution'
import { errorHandler } from '@/utils/errorHandler'
import { required, sameAs, integer } from 'vuelidate/lib/validators'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { EventBus } from '@/utils/eventBus'


export default {
    name: 'Complaint',
    components: {
        PageTitle,
        Details,
        Attachment,
        Causes,
        Commissions,
        Submissions,
        Comments,
        ConfirmDialog,
        Execution,
        CreatedStopCardsDialog,
        TryToCloseStopCardDialog,
    },
    beforeRouteEnter(to, from, next) {
        // Edycja reklamacji
        if (typeof to.params.id !== 'undefined') {
            store.dispatch('complaints/getComplaint', to.params.id)
                .then(response => {
                    const ordersNumbers = response.data.complaintOrderComplaint.map(order => order.orderNumber).join(',')
                    
                    store.dispatch('complaints/setSelectedOrderNumber', ordersNumbers)
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                    store.dispatch('complaints/setUsers', response.data.responsiblePersonRead)
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })

                    Promise.all([
                        store.dispatch('complaints/getComplaintTypes'),
                        store.dispatch('complaints/getComplaintStatuses'),
                        store.dispatch('complaints/getProductionDepartments'),
                        store.dispatch('complaints/getComplaintMaterials'),
                        store.dispatch('complaints/getComplaintUnits'),
                        store.dispatch('administration/getUserPositions'),
                        store.dispatch('administration/getUserSquads'),
                        store.dispatch('complaints/getErrors'),
                        store.dispatch('configurations/getMachines'),
                    ])
                        .then(() => {
                            next(vm => {
                                vm.actionName = 'updateComplaint'
                                vm.complaint = Object.assign({}, response.data)
                                vm.pageTitle = `Reklamacja / Edycja reklamacji - ${vm.complaint.complaintNumber}`
                                vm.isConfirmButtonVisible = (vm.complaint.complaintStatusId === 4 || vm.complaint.complaintStatusId === 8) // statusy uznana oraz uznana przez DMT
                                vm.loading = false
                            })
                        })
                        .catch(error => {
                            next(error)
                            errorHandler(error)
                        })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        // Tworzenie reklamacji
        } else {
            next(vm => {
                vm.preparedForCreating(to)
            })
        }
    },
    data() {
        return {
            loading: true,
            pageTitle: '',
            actionName: '',
            actionLoading: {
                confirmComplaint: false,
                confirmDraftComplaint: false,
                saveComplaint: false
            },
            tabs: null,
            confirmComplaintDialog: false,
            confirmDraftComplaintDialog: false,
            isConfirmButtonVisible: false,
            selectedComplaintTypeId: null,
            createdStopCardsDialog: false,
            complaint: {
                id: null,
                complaintStatusId: 1,
                complaintProductionDepartmentId: null,
                complaintErrorId: null,
                complaintProductDescription: null,
                complaintAttachment: [],
                createdAt: null,
                creator: {
                    id: null,
                },
                createdStopCards: [],
                complaintTypeId: 2,
                complaintTypeName: 'Reklamacja zewnętrzna',
                complaintType: {
                    name: 'Reklamacja zewnętrzna'
                },
                machineId: null,
                priority: false,
                discrepancyCatcherId: null,
                discrepancyDescription: null,
                scaleAmount: null,
                scalePercent: null,
                discrepancyCause: null,
                responsiblePerson: [],
                complaintClassificationId: null,
                inCurrentOrderCb: false,
                inNewOrderCb: false,
                inNewOrderIn: null,
                outage: null,
                fromAdvertisingOrderCb: false,
                newCb: false,
                newIn: null,
                correctiveMeasures: null,
                materialTypeId: null,
                stockAmount: null,
                formatTrimmedCb: false,
                formatTrimmedIn: null,
                unitTypeId: null,
                discountCb: false,
                costWithTransport: 0,
                costWithDiscount: 0,
                complaintCost: 0,
                reprintJobNumber: null,
                reprintJobPlateNumber: null,
                reprint: false,
                reprintAmount: null,
                responsiblePersonRead: null,
                complaintOrderComplaint: [],
                ordersData: [],
            },
            stopCardsForClosing: [],
            showCloseStopCardDialog: false
        }
    },
    validations() {
        return {
            complaint: {
                complaintTypeId:{
                    required
                },
                discrepancyDescription: {
                    required
                },
                scaleAmount: {
                    required,
                    integer
                },
                scalePercent: {
                    required,
                    integer
                },
                inCurrentOrderCb: {
                    sam: sameAs(function() {
                        if (this.complaint.inCurrentOrderCb) {
                            return !(this.complaint.reprint && this.complaint.inNewOrderCb)
                        } else {
                            return this.complaint.reprint && !this.complaint.inNewOrderCb
                        }
                    })
                },
                inNewOrderCb: {
                    sam: sameAs(function() {
                        if (this.complaint.inNewOrderCb) {
                            return !(this.complaint.reprint && this.complaint.inCurrentOrderCb)
                        } else {
                            return this.complaint.reprint && !this.complaint.inCurrentOrderCb
                        }
                    })
                },
                complaintOrderComplaint: {
                    required,
                    $each: {
                        orderNumber: {
                            required
                        },
                    }
                }
            }
        }
    },
    computed: {
        userId() {
            return this.$store.state.user.userId
        },
        isConfirmDraftButtonVisible() {
            return this.isDraftComplaint
        },
        isDraftComplaint() {
            return this.complaint.complaintStatusId === 15
        },
        isComplaintUneditable() {
            return this.isDraftComplaint && (this.complaint.creator.id !== this.userId)
        },
        isComplaintInternal() {
            return this.complaint.complaintTypeId === 1
        },
        fileUploadPending() {
            return this.$store.state.common.progress.show
        },
        canConfirmComplaint() {
            return hasUserPermission('complaints_confirm_update') && this.isConfirmButtonVisible
        },
        canSaveComplaint() {
            return hasUserPermission('complaints_update') || hasUserPermission('complaints_create')
        },
        isNotConfirmed() {
            return this.complaint?.responsiblePersonRead?.find(item => item.id === this.userId)?.confirm === false
        },
        executionTabVisible() {
            return this.complaint?.complaintStatusId !== 15 && this.actionName === 'updateComplaint'
        },
        isStopCardsButtonVisible() {
            return this.complaint.complaintType && this.complaint.complaintType.id === 2
        },
        isLaunchAsPopup() {
            return !!this.$attrs['as-popup']
        },
        stopCard() {
            return this.$attrs['stop-card'] || null
        }
    },
    mounted() {
        this.$root.$on('selectedComplaintTypeId', data => {
            this.selectedComplaintTypeId = data
        })
        this.$root.$on('selectedOrderNumber', data => {
            this.complaint.complaintOrderComplaint = [{orderNumber: data.join()}]
        })
        if (this.isLaunchAsPopup) {
            this.preparedForCreating({
                meta: { title: 'Nowa reklamacja' },
                params: {
                    complaintType: 1, // Reklamacja wewnętrzna
                    fullProductionNumber: this.$attrs.order,
                    productionDepartmentId: this.stopCard?.productionDepartmentId
                }
            })
        }
    },
    methods: {
        preparedForCreating(to) {
            Promise.all([
                this.$store.dispatch('complaints/setSelectedOrderNumber', { selectedOrderNumbers : [] }),
                this.$store.dispatch('complaints/getComplaintTypes'),
                this.$store.dispatch('complaints/getComplaintStatuses'),
                this.$store.dispatch('complaints/getProductionDepartments'),
                this.$store.dispatch('complaints/getErrors'),
                this.$store.dispatch('configurations/getMachines'),
            ])
                .then(() => {
                    this.actionName = 'createComplaint'
                    this.pageTitle = to.meta.title

                    if (to.params.fullProductionNumber) {
                        this.complaint.complaintNumber = to.params.fullProductionNumber
                        this.$store.dispatch('complaints/setSelectedOrderNumber', to.params.fullProductionNumber)
                            .then(() => {
                                EventBus.$emit('selectedOrderNumberManual', to.params.fullProductionNumber)
                            })
                            .catch(error => {
                                errorHandler(error)
                            })
                    }
                    if (to.params.complaintType) {
                        this.complaint.complaintTypeId = to.params.complaintType
                        EventBus.$emit('selectedComplaintTypeManual', to.params.complaintType)
                    }
                    if (to.params.productionDepartmentId) {
                        this.complaint.complaintProductionDepartmentId = to.params.productionDepartmentId
                        EventBus.$emit('selectedProductionDepartmentManual', to.params.productionDepartmentId)
                    }

                    this.loading = false
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCreatedStopCards() {
            this.createdStopCardsDialog = true
        },
        closeCreatedStopCardsDialog() {
            this.createdStopCardsDialog = false
        },
        addComplaintAttachment(file) {
            this.complaint.complaintAttachment.push(file)
        },
        deleteComplaintAttachment(id) {
            const index = this.complaint.complaintAttachment.findIndex(item => item.id === id)

            this.complaint.complaintAttachment.splice(index, 1)
        },
        saveComplaint() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.actionLoading.saveComplaint = true
                if (this.actionName === 'createComplaint') {
                    let payload = {
                        ...this.complaint,
                        complaintAttachmentId: this.complaint.complaintAttachment.map(item => item.id),
                        complaintOrderComplaint: this.complaint.complaintOrderComplaint.map(({ id, ...orderComplaint }) => orderComplaint)
                    }

                    delete payload.id
                    delete payload.complaintAttachment

                    if (this.isLaunchAsPopup && this.stopCard) {
                        payload.stopCardId = this.stopCard.id
                    }

                    this.$store.dispatch(`complaints/${this.actionName}`, payload)
                        .then(response => {
                            this.complaint = response.data
                            EventBus.$emit('complaintCreated', response)
                            if (this.isLaunchAsPopup) { this.closePopUp() }
                            else if (this.complaint.createdStopCards && this.complaint.createdStopCards.length > 0) {
                                this.tryToCloseStopCard(this.complaint.createdStopCards)
                            }

                            this.$v.$reset()
                        })
                        .catch(error => {
                            errorHandler(error)
                            this.actionLoading.saveComplaint = false
                        })
                        .finally(() => {
                            this.actionLoading.saveComplaint = false
                        })
                }

                if (this.actionName === 'updateComplaint') {
                    let payload = {
                        ...this.complaint,
                        complaintAttachmentId: this.complaint.complaintAttachment.map(item => item.id),
                    }

                    delete payload.complaintAttachment


                    this.$store.dispatch(`complaints/${this.actionName}`, payload
                    )
                        .then(() => {
                            this.close()
                        })
                        .catch(error => {
                            errorHandler(error)
                        })
                        .finally(() => {
                            this.actionLoading.saveComplaint = false
                        })
                }
                this.$v.$reset()
            }
        },
        tryToCloseStopCard(stopCards) {
            this.stopCardsForClosing = stopCards
            this.showCloseStopCardDialog = true
        },
        showConfirmComplaintDialog() {
            this.confirmComplaintDialog = true
        },
        showConfirmDraftComplaintDialog() {
            this.confirmDraftComplaintDialog = true
        },
        confirmDraftComplaint() {
            this.actionLoading.confirmDraftComplaint = true

            let { complaintAttachment, ...restOfComplaint } = this.complaint

            this.$store.dispatch('complaints/updateComplaint', {
                ...restOfComplaint,
                complaintStatusId: 1 // new
            })
                .then(() => {
                    this.close()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.confirmDraftComplaint = false
                    this.confirmDraftComplaintDialog = false
                })
        },
        confirmComplaint() {
            this.actionLoading.confirmComplaint = true

            let { complaintAttachment, ...restOfComplaint } = this.complaint

            this.$store.dispatch('complaints/updateComplaint', {
                ...restOfComplaint,
                confirm: true // Confirm complaint
            })
                .then(() => {
                    this.close()
                })
                .catch(error => errorHandler(error))
                .finally(() => {
                    this.actionLoading.confirmComplaint = false
                    this.confirmComplaintDialog = false
                })
        },
        closeConfirmComplaintDialog() {
            this.confirmComplaintDialog = false
        },
        closeConfirmDraftComplaintDialog() {
            this.confirmDraftComplaintDialog = false
        },
        close() {
            this.$router.push({ name: 'complaintsComplaints'})
                .catch(error => {
                    errorHandler(error)
                })
            this.$v.$reset()
        },
        closePopUp() {
            this.$emit('close')
        }
    }
}
</script>

